import React from 'react';
import { Content, Row, Col, Title, Text, Pagination, Button } from 'components';
import { SideMenu } from '../components';
import OrderItem from '../components/OrderItem/OrderItem';
import { Empty, Spin, Tag } from 'antd';
import { ReviewItem } from 'routes/main.routes/ProductDetail/components';
import Formatter from 'utils/Formatter';
import { STORE_URL, stringToMoneyFormat } from 'utils';

const PAGE_COUNT = 5;
const PAGE_SIZE = 5;

const MypageReviewPresenter = (props) => {
  /* ===== Props ===== */
  const {
    user,
    order,
    tapItem,
    selectedTab,
    onTabChange,
    screenSize,
    onSubmit,
    isLoading,
  } = props;

  /* ===== State ===== */
  const [currentPage, setCurrentPage] = React.useState(1);

  return (
    <React.Fragment>
      <Spin spinning={isLoading}>
        <Content
          maxWidth={1820}
          padding={screenSize >= 768 ? '120px 0px' : '60px 0'}
        >
          <Row gutter={25}>
            <Col x={0} md={1} xl={2}></Col>
            <Col x={0} md={6} xl={4}>
              <SideMenu />
            </Col>
            <Col x={24} md={16} xl={16}>
              <Content
                maxWidth={'100%'}
                padding={
                  screenSize >= 1200
                    ? '0 0 0 95px'
                    : screenSize >= 768
                    ? '0 0 0 20px'
                    : '0'
                }
              >
                <Title
                  style={{
                    fontSize:
                      screenSize >= 768 ? 32 : screenSize >= 500 ? 28 : 20,
                    fontWeight: 700,
                    marginBottom: 24,
                    fontFamily: 'Pretendard',
                  }}
                >
                  상품리뷰
                </Title>

                {/* 탭 메뉴 */}
                <div
                  style={{
                    display: 'flex',
                    borderBottom: '2px solid var(--black-color)',
                  }}
                >
                  {tapItem.map((tab) => (
                    <div
                      key={`tab-${tab.value}`}
                      style={{
                        width: screenSize >= 768 ? 160 : 130,
                        height: screenSize >= 768 ? 66 : 55,
                        lineHeight: screenSize >= 768 ? '66px' : '55px',
                        textAlign: 'center',
                        cursor: 'pointer',
                        fontSize: screenSize >= 768 ? 16 : 14,
                        border: '1px solid gray',
                        backgroundColor:
                          selectedTab === tab.value ? 'black' : 'transparent',
                        color: selectedTab === tab.value ? 'white' : 'gray',
                        fontWeight:
                          selectedTab === tab.value ? 'bold' : 'normal',
                      }}
                      onClick={() => {
                        onTabChange(tab.value);
                        setCurrentPage(1); // 페이지 초기화
                      }}
                    >
                      {tab.label}({order[tab.value].length})
                    </div>
                  ))}
                </div>

                {/* 리뷰 리스트 */}
                <div style={{ minWidth: '62%' }}>
                  {!order[selectedTab].length ? (
                    <div style={{ paddingTop: 30 }}>
                      <Empty
                        description={
                          selectedTab === 'BEFORE'
                            ? '작성 가능한 리뷰가 없습니다.'
                            : '나의 리뷰가 없습니다.'
                        }
                      />
                    </div>
                  ) : (
                    order[selectedTab]
                      .slice(
                        (currentPage - 1) * PAGE_COUNT,
                        currentPage * PAGE_COUNT
                      )
                      .map((review) => (
                        <div
                          key={`review-${
                            review.parcel_service_id
                              ? review.parcel_service_id
                              : review?.rental_id
                          }`}
                          style={{
                            //padding: '32px 0',
                            borderBottom: '1px solid var(--black-color)',
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              flexWrap: 'wrap',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              padding: '32px 0',
                              //borderBottom: '1px solid #ddd',
                              flexDirection:
                                screenSize >= 768 ? 'unset' : 'column',
                              rowGap: 20,
                            }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                alignItems:
                                  screenSize >= 768 ? 'center' : 'start',
                                width: screenSize >= 768 ? '54%' : '100%',
                                minWidth: screenSize >= 768 ? 560 : 'auto',
                                flexDirection:
                                  screenSize >= 768 ? 'unset' : 'column',
                                rowGap: 20,
                              }}
                            >
                              <div
                                style={{
                                  width: screenSize >= 768 ? '20%' : '100px',
                                  display: 'flex',
                                  flexDirection: 'column',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                }}
                              >
                                <Text>
                                  {Formatter.unixToDate(
                                    review?.created_at,
                                    'YYYY.MM.DD'
                                  )}
                                </Text>
                                {/* {selectedTab === 'BEFORE' ? null : (
                                  <Tag
                                    color={
                                      review?.review?.is_show
                                        ? review?.review?.is_show === 'Y'
                                          ? 'success'
                                          : 'error'
                                        : 'default'
                                    }
                                  >
                                    {review?.review?.is_show
                                      ? review?.review?.is_show === 'Y'
                                        ? '승인'
                                        : '미승인'
                                      : '심사중'}
                                  </Tag>
                                )} */}
                              </div>
                              <OrderItem
                                screenSize={screenSize}
                                src={review?.product?.thumbnail}
                                placeName={
                                  review?.product?.shop_information_name
                                }
                                productName={review?.product?.product_name}
                                subName={
                                  review?.parcel_service_id
                                    ? null
                                    : `계약기간 ${
                                        review?.contract_date
                                      }개월 / 의무사용기간 ${
                                        review?.mandatory_usage_date
                                      }개월${
                                        review?.advance_price
                                          ? ` / 선납입금 ${stringToMoneyFormat(
                                              review?.advance_price,
                                              '원'
                                            )}`
                                          : ''
                                      }`
                                }
                                productData={
                                  review?.product?.product_option
                                    ? review?.product?.product_option
                                        .map((cur) =>
                                          cur.option
                                            .map((op) => op.option_name)
                                            .join(' / ')
                                        )
                                        .join(' / ')
                                    : null
                                }
                              />
                            </div>
                            {selectedTab === 'BEFORE' ? (
                              <Button
                                style={{
                                  padding: '2px 8px',
                                  fontSize: 14,
                                  borderRadius: 0,
                                  marginLeft: screenSize >= 768 ? '0' : 'auto',
                                }}
                                onClick={() => onSubmit('create', review)}
                              >
                                리뷰쓰기
                              </Button>
                            ) : review?.review?.is_show === 'Y' ? null : (
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'end',
                                  gap: 16,
                                }}
                              >
                                <Button
                                  style={{
                                    width: 65,
                                    padding: '2px 8px',
                                    fontSize: 14,
                                    borderRadius: 0,
                                  }}
                                  onClick={() =>
                                    onSubmit('update', review?.review)
                                  }
                                >
                                  수정
                                </Button>
                                <Button
                                  type="secondary"
                                  style={{
                                    width: 65,
                                    padding: '2px 8px',
                                    fontSize: 14,
                                    borderRadius: 0,
                                  }}
                                  onClick={() =>
                                    onSubmit('delete', review?.review)
                                  }
                                >
                                  삭제
                                </Button>
                              </div>
                            )}
                          </div>
                          {/* 리뷰 내용이 들어갈 자리 */}
                          {selectedTab === 'BEFORE' ? null : (
                            <div
                              style={{
                                borderTop: '1px solid #ddd',
                              }}
                            >
                              <div>
                                <ReviewItem
                                  score={review?.review?.review_score}
                                  name={user?.user_name}
                                  created_at={Formatter.unixToDate(
                                    review?.review?.created_at,
                                    'YYYY.MM.DD'
                                  )}
                                  content={review?.review?.review_content}
                                  option={`${review?.product?.product_name}`}
                                  img={review?.review?.review_file?.map(
                                    (file) => ({
                                      ...file,
                                      file_url: `${STORE_URL}/${file.file_url}`,
                                    })
                                  )}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      ))
                  )}
                </div>

                {/* 페이지네이션 */}
                <div style={{ marginTop: 100 }}>
                  <Pagination
                    total={order[selectedTab].length}
                    pageSize={PAGE_SIZE}
                    current={currentPage}
                    onChange={(page) => setCurrentPage(page)}
                    showSizeChanger
                    onShowSizeChange={(_, size) => {
                      setCurrentPage(1); // 페이지 크기 변경 시 페이지 초기화
                    }}
                    showPage={5}
                    buttonStyle={{
                      fontSize: 16,
                      fontWeight: 700,
                      color: '#999999',
                      background: 'none',
                      width: 28,
                      height: 28,
                    }}
                    isButton={true}
                    activeStyle={{
                      color: `var(--black-color) !important`,
                      borderBottom: '2px solid #111111',
                    }}
                    hoverStyle={{
                      color: `var(--black-color) !important`,
                    }}
                    navStyle={{
                      border: '1px solid var(--black-color)',
                    }}
                    isLatestButton={true}
                  />
                </div>
              </Content>
            </Col>
            <Col x={0} md={1} xl={2}></Col>
          </Row>
        </Content>
      </Spin>
    </React.Fragment>
  );
};

export default MypageReviewPresenter;
